module.exports = "<div>\n  Loading<span class=\"d\">.</span><span class=\"d d-2\">.</span><span class=\"d d-3\">.</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/loader/loader.component.html
// module id = ./src/app/shared/component/loader/loader.component.html
// module chunks = main